import React, { useEffect, useState } from 'react';


import { ThemeProvider } from '@material-ui/styles';

import theme from '../PimTogoTheme';
import PdfLanguageSelector from './PdfLanguageSelector';
import ajaxCall from 'src/services/ajaxCall';


export default function PdfPreviewTrigger() {
  const [langSets, setLangSets] = useState([]);
  const [openPdfPreview, setOpenPdfPreview] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);

  useEffect(() => {
    ajaxCall({
      httpMethod: 'get',
      url: 'pdfpreviewPublicationLanguageSets'
    }).then((ajaxData) => {
      if (!ajaxData.error && ajaxData.response?.languageSets.length) {
        setLangSets(ajaxData.response.languageSets);
      }
    });

    $('.treeViewWrapper')
      .off(
        'togo.pdfPreview.openPdfPreviewLangSelector',
        '.catalog2goWrap'
      )
      .on(
        'togo.pdfPreview.openPdfPreviewLangSelector',
        '.catalog2goWrap',
        function (_, url) {
          setPdfUrl(url);
          setOpenPdfPreview(true);
        }
      );

  }, []);

  return (
    <ThemeProvider theme={theme}>
      <PdfLanguageSelector
        setOpenPdfPreview={setOpenPdfPreview}
        openPdfPreview={openPdfPreview}
        langSets={langSets}
        pdfURL={pdfUrl}
      />
    </ThemeProvider>
  );
}
